'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDocument$002dKind$0024 from "./presto.types$-Document-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$64() {
  this.aHp = null;
  this.aHn = null;
  this.aHo = false;
  this.aHl = null;
  this.aHm = false;
  this.aHq = false;
  this.aHr = false;
  this.aHp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$64 as $c_Lpresto_CredentialsView$$anon$64 };
$p = $c_Lpresto_CredentialsView$$anon$64.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$64;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$64() {
}
export { $h_Lpresto_CredentialsView$$anon$64 as $h_Lpresto_CredentialsView$$anon$64 };
$h_Lpresto_CredentialsView$$anon$64.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aHp;
});
$p.t = (function() {
  if ((!this.aHo)) {
    this.aHn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHo = true;
  }
  return this.aHn;
});
$p.ae = (function() {
  if ((!this.aHm)) {
    this.aHl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dDocument$002dKind$0024.$m_Lpresto_types$DocumentKind$().adz()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHm = true;
  }
  return this.aHl;
});
$p.w = (function() {
  if ((!this.aHr)) {
    this.aHq = false;
    this.aHr = true;
  }
  return this.aHq;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$64, "presto.CredentialsView$$anon$64", ({
  G7: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$64 as $d_Lpresto_CredentialsView$$anon$64 };
//# sourceMappingURL=presto.-Credentials-View$$anon$64.js.map
